var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m12.91 9.992-6.597 7.05c-.45.48-.41 1.223.09 1.657a1.257 1.257 0 0 0 1.725-.09l7.77-8.303a.45.45 0 0 0 0-.614L8.128 1.39a1.254 1.254 0 0 0-1.724-.09 1.145 1.145 0 0 0-.09 1.66l6.595 7.032z"
})));
export default SvgIconChevronRight;